<div class="informations border-light border rounded-lg bg-white p-8 md:mt-10 mt-5">
  <div class="flex items-center justify-between mb-6">
    <h1 class="font-app-bold text-xl">
      {{ "userInfo.consentTitle" | translate }}
    </h1>
  </div>
  <hr class="text-lightest mb-4" />
  <form [formGroup]="userConsent">
    <div class="md:grid md:grid-cols-4 md:gap-8 flex flex-col mb-4">
      <div>
        <p class="text-dark">{{ "userInfo.emailConsent" | translate }}</p>
        <div class="flex items-center mt-2">
          <div class="flex items-center mr-4 text-darkest">
            <p-radioButton
              formControlName="emailConsent"
              [value]="true"
              [label]="'generalOptions.yes' | translate"
              class="mr-1" />
          </div>
          <div class="flex items-center text-darkest">
            <p-radioButton
              formControlName="emailConsent"
              [value]="false"
              [label]="'generalOptions.no' | translate"
              class="mr-1" />
          </div>
        </div>
      </div>
      <div class="mt-7 md:mt-0">
        <p class="text-dark">{{ "userInfo.callConsent" | translate }}</p>
        <div class="flex items-center mt-2">
          <div class="flex items-center mr-4 text-darkest">
            <p-radioButton
              formControlName="smsConsent"
              [value]="true"
              [label]="'generalOptions.yes' | translate"
              class="mr-1" />
          </div>
          <div class="flex items-center text-darkest">
            <p-radioButton
              formControlName="smsConsent"
              [value]="false"
              [label]="'generalOptions.no' | translate"
              class="mr-1" />
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

